<template>
    <table class="table table-zebra max-w-md">
        <tbody>
            <tr v-if="customFields?.caloric_value_kj && customFields?.caloric_value_kcal">
                <td>
                    <div>{{ t('product.tabsNutrition.calorificValue') }}</div>
                </td>
                <td>
                    <div>{{ customFields?.caloric_value_kj }} kJ / {{ customFields?.caloric_value_kcal }} kcal</div>
                </td>
            </tr>

            <tr v-if="customFields?.fat && customFields?.fatty_acids">
                <td>
                    <div>{{ t('product.tabsNutrition.fat') }}</div>
                    <div class="ps-2">
                        {{ t('product.tabsNutrition.fat2') }}
                    </div>
                </td>
                <td>
                    <div>{{ customFields?.fat }}g</div>
                    <div>{{ customFields?.fatty_acids }}g</div>
                </td>
            </tr>

            <tr v-if="customFields?.carbohydrates && customFields?.sugar">
                <td>
                    <div>{{ t('product.tabsNutrition.carbohydrates') }}</div>
                    <div class="ps-2">
                        {{ t('product.tabsNutrition.carbohydrates2') }}
                    </div>
                </td>
                <td>
                    <div>{{ customFields?.carbohydrates }}g</div>
                    <div>{{ customFields?.sugar }}g</div>
                </td>
            </tr>

            <tr v-if="customFields?.protein">
                <td>
                    <div>{{ t('product.tabsNutrition.protein') }}</div>
                </td>
                <td>
                    <div>{{ customFields?.protein }}g</div>
                </td>
            </tr>

            <tr v-if="customFields?.salt">
                <td>
                    <div>{{ t('product.tabsNutrition.salt') }}</div>
                </td>
                <td>
                    <div>{{ customFields?.salt }}g</div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n'

const {t} = useI18n()

const props = defineProps<{
    customFields?: object,
}>()
</script>
